import React from 'react';
export function BonusSection() {
  return <section className="bg-[#0a0e27] py-4 md:py-6 px-4 font-sans" data-id="element-19">
      <div className="max-w-5xl mx-auto" data-id="element-20">
        {/* Header */}
        <div className="text-center mb-4" data-id="element-21">
          <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-1" data-id="element-22">
            BONUS exclusivos incluidos con tu compra
          </h2>
          <div className="inline-block bg-gradient-to-r from-red-600 to-orange-500 text-white font-bold px-5 py-1.5 rounded-md shadow-[0_0_15px_rgba(239,68,68,0.5)] border border-red-400" data-id="element-23">
            🎁 ¡GRATIS POR EL DÍA DE HOY!
          </div>
        </div>

        {/* Bonus Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-4 max-w-4xl mx-auto" data-id="element-24">
          {/* Bonus 1 */}
          <div className="bg-[#111638] rounded-lg p-3 border border-gray-800 border-l-4 border-l-red-500 relative overflow-hidden flex flex-col h-full" data-id="element-25">
            <div className="absolute top-0 right-1 text-7xl font-black text-red-500/10 select-none pointer-events-none leading-none mt-1" data-id="element-26">
              01
            </div>
            <div className="mb-1.5" data-id="element-27">
              <span className="bg-red-500 text-white text-xs font-bold px-2.5 py-0.5 rounded-full uppercase tracking-wider" data-id="element-28">
                Bono #01
              </span>
            </div>
            <h3 className="text-xl font-bold text-white mb-1 relative z-10" data-id="element-29">
              Calculadora "Precio Real AR"
            </h3>
            <p className="text-gray-400 text-sm mb-2 flex-grow relative z-10" data-id="element-30">
              Plantilla Google Sheets + Excel + versión imprimible A4. Convierte
              cualquier precio en horas de vida, proyecta el impacto de la
              inflación y arma un plan de ahorro en 60 segundos. Lista para usar
              en clase desde el primer día.
            </p>
            <div className="flex items-center justify-between mt-auto relative z-10 border-t border-gray-800 pt-2" data-id="element-31">
              <span className="text-gray-500 line-through text-sm" data-id="element-32">
                Valor $8.500
              </span>
              <span className="bg-[#22c55e] text-white text-sm font-bold px-3 py-0.5 rounded-md" data-id="element-33">
                HOY GRATIS
              </span>
            </div>
          </div>

          {/* Bonus 2 */}
          <div className="bg-[#111638] rounded-lg p-3 border border-gray-800 border-l-4 border-l-blue-500 relative overflow-hidden flex flex-col h-full" data-id="element-34">
            <div className="absolute top-0 right-1 text-7xl font-black text-blue-500/10 select-none pointer-events-none leading-none mt-1" data-id="element-35">
              02
            </div>
            <div className="mb-1.5" data-id="element-36">
              <span className="bg-blue-500 text-white text-xs font-bold px-2.5 py-0.5 rounded-full uppercase tracking-wider" data-id="element-37">
                Bono #02
              </span>
            </div>
            <h3 className="text-xl font-bold text-white mb-1 relative z-10" data-id="element-38">
              50 Prompts de IA para Docentes
            </h3>
            <p className="text-gray-400 text-sm mb-2 flex-grow relative z-10" data-id="element-39">
              50 prompts listos para copiar y pegar en ChatGPT o Claude. Generan
              exámenes, casos de estudio, debates y secuencias didácticas
              adaptados al contexto argentino en menos de 30 segundos.
            </p>
            <div className="flex items-center justify-between mt-auto relative z-10 border-t border-gray-800 pt-2" data-id="element-40">
              <span className="text-gray-500 line-through text-sm" data-id="element-41">
                Valor $8.500
              </span>
              <span className="bg-[#22c55e] text-white text-sm font-bold px-3 py-0.5 rounded-md" data-id="element-42">
                HOY GRATIS
              </span>
            </div>
          </div>

          {/* Bonus 3 */}
          <div className="bg-[#111638] rounded-lg p-3 border border-gray-800 border-l-4 border-l-purple-500 relative overflow-hidden flex flex-col h-full" data-id="element-43">
            <div className="absolute top-0 right-1 text-7xl font-black text-purple-500/10 select-none pointer-events-none leading-none mt-1" data-id="element-44">
              03
            </div>
            <div className="mb-1.5" data-id="element-45">
              <span className="bg-purple-500 text-white text-xs font-bold px-2.5 py-0.5 rounded-full uppercase tracking-wider" data-id="element-46">
                Bono #03
              </span>
            </div>
            <h3 className="text-xl font-bold text-white mb-1 relative z-10" data-id="element-47">
              Manual del Freelancer Sub-20
            </h3>
            <p className="text-gray-400 text-sm mb-2 flex-grow relative z-10" data-id="element-48">
              Guía paso a paso para que tus alumnos empiecen a cobrar en dólares
              desde Argentina siendo menores de edad. Plataformas, tipo de
              cambio conveniente y cómo armar un perfil profesional sin
              experiencia previa.
            </p>
            <div className="flex items-center justify-between mt-auto relative z-10 border-t border-gray-800 pt-2" data-id="element-49">
              <span className="text-gray-500 line-through text-sm" data-id="element-50">
                Valor $8.500
              </span>
              <span className="bg-[#22c55e] text-white text-sm font-bold px-3 py-0.5 rounded-md" data-id="element-51">
                HOY GRATIS
              </span>
            </div>
          </div>

          {/* Bonus 4 */}
          <div className="bg-[#111638] rounded-lg p-3 border border-gray-800 border-l-4 border-l-orange-500 relative overflow-hidden flex flex-col h-full" data-id="element-52">
            <div className="absolute top-0 right-1 text-7xl font-black text-orange-500/10 select-none pointer-events-none leading-none mt-1" data-id="element-53">
              04
            </div>
            <div className="mb-1.5" data-id="element-54">
              <span className="bg-orange-500 text-white text-xs font-bold px-2.5 py-0.5 rounded-full uppercase tracking-wider" data-id="element-55">
                Bono #04
              </span>
            </div>
            <h3 className="text-xl font-bold text-white mb-1 relative z-10" data-id="element-56">
              Protocolo "Botón Rojo"
            </h3>
            <p className="text-gray-400 text-sm mb-2 flex-grow relative z-10" data-id="element-57">
              Ficha imprimible A4 con el protocolo de emergencia ante robo,
              hackeo o estafa. Incluye directorio completo de teléfonos de
              bloqueo de todos los bancos y billeteras argentinas.
            </p>
            <div className="flex items-center justify-between mt-auto relative z-10 border-t border-gray-800 pt-2" data-id="element-58">
              <span className="text-gray-500 line-through text-sm" data-id="element-59">
                Valor $8.500
              </span>
              <span className="bg-[#22c55e] text-white text-sm font-bold px-3 py-0.5 rounded-md" data-id="element-60">
                HOY GRATIS
              </span>
            </div>
          </div>
        </div>

        {/* Total Value Box */}
        <div className="max-w-sm mx-auto bg-[#111638] border border-gray-700 rounded-lg p-3 text-center shadow-2xl" data-id="element-61">
          <p className="text-gray-400 text-sm mb-0.5" data-id="element-62">
            Valor total de los 4 bonus:
          </p>
          <p className="text-2xl font-bold text-red-500 line-through decoration-2 mb-1" data-id="element-63">
            $34.000
          </p>
          <p className="text-white font-bold text-base mb-0.5" data-id="element-64">
            Hoy te los llevás por:
          </p>
          <p className="text-6xl font-black text-[#22c55e] mb-1 drop-shadow-[0_0_10px_rgba(34,197,94,0.3)]" data-id="element-65">
            $0
          </p>
          <p className="text-yellow-400 font-bold text-sm" data-id="element-66">
            ✨ Incluidos GRATIS con tu compra de hoy ✨
          </p>
        </div>
      </div>
    </section>;
}